import React from "react";
import { ChangeRequestProvider } from "src/context/ChangeRequestContext";
import { ChangeRequestContainer } from "../change-request";

export const DraftChangeRequest: React.FC = () => {
  return (
    <ChangeRequestProvider>
      <ChangeRequestContainer data-id="draftChangeRequestDetail" />
    </ChangeRequestProvider>
  );
};
